export default {
	namespaced: true,
	state: {
		isSignIn: false,
		isAdminPage: false,
		authToken: '',
		refreshToken: ''
	},
	getters: {
		isSignIn: (state) => state.isSignIn,
		isAdminPage: (state) => state.isAdminPage,
		authToken: (state) => state.authToken,
		refreshToken: (state) => state.refreshToken
	},
	mutations: {
		pageAdmin: (state, payload) => (state.isAdminPage = payload),
		signIn(state, payload) {
			state.isSignIn = true
			state.authToken = payload.authToken
			state.refreshToken = payload.refreshToken
		},
		signOut(state) {
			state.isSignIn = false
			state.authToken = ''
			state.refreshToken = ''
		}
	},
	actions: {
		pageAdmin: ({ commit }, payload) => commit('pageAdmin', payload),
		async signIn({ commit, dispatch }, payload) {
			const { data } = await this._vm.$axios.post('/login', payload)
			commit('signIn', data)
			setInterval(() => {
				dispatch('refreshToken')
			}, 240000) // refresh every 4 min 240000
		},
		signOut: ({ commit }) => commit('signOut'),
		async refreshToken({ commit, state }) {
			const { data } = await this._vm.$axios.post('/refreshLogin', {
				refreshToken: state.refreshToken
			})
			commit('signIn', data)
		}
	}
}
